<p class="title">REGISTRO DE ALARMAS DISPARADAS</p>

<ul>
    <li>Alarma 1      </li>
    <li>Alarma 2      </li>
    

</ul>
